module.exports = __webpack_public_path__ + "img/image60.76adf04e.png";